import styled from 'styled-components';

import { theme } from '../../../common/ui/theme';

interface DotsWrapperProps {
    pageTotal?: number;
}

const DotsWrapper = styled.div<DotsWrapperProps>`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: ${theme.sizes[24]};
    width: ${(props) => {
        if (!props.pageTotal || props.pageTotal < 100) {
            return '32px';
        }
        return '44px';
    }};
    color: ${theme.colors.foreground.default};
    background-color: transparent;
    border-radius: ${theme.radii[4]};
    margin-left: ${theme.space[2]};
    margin-right: ${theme.space[2]};
`;

interface PaginationDotsProps {
    pageTotal?: number;
}

export const PaginationDots = ({ pageTotal }: PaginationDotsProps) => {
    return <DotsWrapper pageTotal={pageTotal}>&hellip;</DotsWrapper>;
};
